module.exports = __webpack_public_path__ + "img/cy.cyc956003.svg";